/**
 * 计算结果缓存工具
 */

// 缓存对象
const calculationCache = new Map();

/**
 * 生成缓存键
 * @param {Object} params - 计算参数
 * @returns {string} 缓存键
 */
export const generateCacheKey = (params) => {
  return JSON.stringify(params);
};

/**
 * 获取缓存的计算结果
 * @param {Object} params - 计算参数
 * @returns {Object|null} 缓存的结果或null
 */
export const getCachedResult = (params) => {
  const cacheKey = generateCacheKey(params);
  if (calculationCache.has(cacheKey)) {
    return calculationCache.get(cacheKey);
  }
  return null;
};

/**
 * 缓存计算结果
 * @param {Object} params - 计算参数
 * @param {Object} result - 计算结果
 */
export const cacheResult = (params, result) => {
  const cacheKey = generateCacheKey(params);
  calculationCache.set(cacheKey, result);
  
  // 限制缓存大小，最多保存100条记录
  if (calculationCache.size > 100) {
    const firstKey = calculationCache.keys().next().value;
    calculationCache.delete(firstKey);
  }
};

/**
 * 清除缓存
 */
export const clearCache = () => {
  calculationCache.clear();
};